import PrkCollapsible from '../prk/prk-collapsible';
import { ScrollableNav } from '../scrollable-nav';

export const initScrollableNavigations = function() {
    // If on desktop layout
    if (document.querySelector('.desk#wrapper') instanceof HTMLElement) {
        const selector = `.${ScrollableNav.ELEMENT_CLASS}:not(.${ScrollableNav.INITIALIZATION_CLASS})`;
        const navElements = document.querySelectorAll(selector);
        for (const nav of [...navElements]) {
            new ScrollableNav(nav);
        }
    }
}

export const initThreeLinesCollapsible = function(elementClassName) {
    const containerClassName = `${elementClassName}__container`;
    const itemClassName = `${elementClassName}__item`;

    const collapsibleElement = document.querySelector(`.${elementClassName}`);
    if (collapsibleElement instanceof HTMLElement) {
        const itemContainer = collapsibleElement.querySelector(`.${containerClassName}`);
        const items = [...itemContainer.querySelectorAll(`.${itemClassName}`)];
        const getCollapsedHeight = () => {
            if (!items.length)
                return 0;

            const { lineHeight } = getComputedStyle(collapsibleElement)
            const betweenRowMarginHeight = parseFloat(lineHeight); // Use line height as margin between rows equals 1em
            const itemHeight = items[0].offsetHeight;
            const collapsedHeight = Math.min(itemContainer.scrollHeight, 3 * itemHeight + 2 * betweenRowMarginHeight);

            return collapsedHeight;
        };
        
        const collapsible = new PrkCollapsible(collapsibleElement, {
            collapsedHeight: getCollapsedHeight,
            onBeforeExpand: resolve => {
                collapsibleElement.classList.add('hide-show-more-btn');
                resolve();
            },
        });

        if (itemContainer.scrollHeight <= getCollapsedHeight()) {
            collapsible.expand();
        }
    }
}
